import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { App } from '@df/core/app';
import { GridModule } from '@df/ui/atomic/atom/grid/grid.module';
import { UiComponent } from '@df/ui/ui.component';
import { ICmsClientModule } from '@icms/client/icms-client.module';
import { ICmsComponent, ICmsContent, NICmsContentComponent } from '@icms/core/content';
import { ScrollAnimationDirective } from '../../ui/display/scroll-animation.directive';
import { CMS_COMPONENT_CMS_CONFIG } from './cms-component-row.config';
import { NCmsComponentRow } from './cms-component-row.interface';

@Component({
    selector: 'cms-component-row',
    templateUrl: './cms-component-row.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [CommonModule, ScrollAnimationDirective, GridModule, ICmsClientModule]
})
@ICmsComponent<CmsComponentRowComponent>({ isAdvanced: false, ...CMS_COMPONENT_CMS_CONFIG })
export class CmsComponentRowComponent extends UiComponent implements NICmsContentComponent.IComponent {
    @ICmsContent({
        type: 'component'
    })
    component!: NCmsComponentRow.IData;

    constructor(protected app: App) {
        super();
    }

    override ngOnInit(): void {
        this.subscriptions.add(
            this.app.meta.subscribe(() => {
                this.detectChanges();
            })
        );
        super.ngOnInit();
    }

    get isFacet(): boolean {
        return !!this.app.meta.state?.route?.data?.facet?.category;
    }
}
